import {SOPostPerson} from '../../core/person/so-post-person';
import {PersonCore} from './person.core';
import {SOGetPerson} from '../../core/person/so-get-person';
import {FormField, SelectionOption} from 'lionheartland';
import {postPersonFormFieldOptions} from './post-person-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {UserCore} from '../user/user.core';
import {SOGetUser} from '../../core/user/so-get-user';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostPerson extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postPersonFormFieldOptions);

  RequestClass = SOPostPerson

  constructor(
    public entityCore: PersonCore
  ) {
    super();
    if (postPersonFormFieldOptions.user) {
      postPersonFormFieldOptions.user.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('relation'),
      this.getFormValueFromIdentifier(
        'user',
        SOGetUser,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}